import type { FilmTitle } from "@/types/film";

export const tvSeries: FilmTitle[] = [
  {
    id: "t-01",
    title: "绝命毒师",
    originalTitle: "Breaking Bad",
    type: "tv",
    year: 2008,
    endYear: 2013,
    genres: ["剧情", "犯罪", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 9.6,
    popularity: 985,
    duration: "每集 47 分钟",
    episodes: "全 5 季 62 集",
    director: "文斯·吉利根",
    cast: ["布莱恩·科兰斯顿", "亚伦·保尔", "安娜·冈"],
    synopsis:
      "身患绝症的化学老师为给家人留下积蓄，踏上制毒之路。一步错，步步错，一个普通人的堕落被拍成了最惊心动魄的旅程。",
    tags: ["经典", "高分", "热播"],
    awards: ["16 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20crime%20drama%20poster%20art%20of%20a%20balding%20man%20in%20a%20yellow%20hazmat%20suit%20standing%20in%20a%20desert%20under%20harsh%20sunlight%2C%20rv%20camper%20behind%2C%20gritty%20warm%20orange%20tones&width=480&height=640&seq=tv-01&orientation=portrait",
  },
  {
    id: "t-02",
    title: "权力的游戏",
    originalTitle: "Game of Thrones",
    type: "tv",
    year: 2011,
    endYear: 2019,
    genres: ["奇幻", "剧情", "冒险"],
    region: "美国",
    language: "英语",
    rating: 9.4,
    popularity: 977,
    duration: "每集 57 分钟",
    episodes: "全 8 季 73 集",
    director: "大卫·贝尼奥夫",
    cast: ["艾米莉亚·克拉克", "基特·哈灵顿", "彼特·丁拉基"],
    synopsis:
      "七大王国为铁王座明争暗斗，凛冬将至，异鬼在北境集结。权力、家族与生存的宏大棋盘上，没有人是安全的。",
    tags: ["经典", "高分"],
    awards: ["59 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=epic%20fantasy%20tv%20poster%20art%20of%20a%20glowing%20iron%20throne%20in%20a%20dark%20hall%20with%20winter%20snow%20drifting%20through%20broken%20windows%2C%20cold%20blue%20light%20and%20torch%20flame%2C%20grand%20scale&width=480&height=640&seq=tv-02&orientation=portrait",
  },
  {
    id: "t-03",
    title: "老友记",
    originalTitle: "Friends",
    type: "tv",
    year: 1994,
    endYear: 2004,
    genres: ["喜剧", "爱情"],
    region: "美国",
    language: "英语",
    rating: 9.8,
    popularity: 941,
    duration: "每集 22 分钟",
    episodes: "全 10 季 236 集",
    director: "大卫·克莱恩",
    cast: ["詹妮弗·安妮斯顿", "柯特妮·考克斯", "马修·派瑞"],
    synopsis:
      "纽约曼哈顿的六个好朋友，在咖啡馆与公寓之间分享工作、爱情与生活的鸡毛蒜皮。最平凡的日子，也最治愈人心。",
    tags: ["经典", "高分"],
    awards: ["6 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20sitcom%20poster%20art%20of%20six%20friends%20laughing%20together%20on%20a%20cozy%20orange%20couch%20in%20a%20bright%20new%20york%20apartment%2C%20colorful%20retro%20furniture%2C%20cheerful%20nostalgic%20mood&width=480&height=640&seq=tv-03&orientation=portrait",
  },
  {
    id: "t-04",
    title: "怪奇物语",
    originalTitle: "Stranger Things",
    type: "tv",
    year: 2016,
    endYear: 2025,
    genres: ["科幻", "悬疑", "恐怖"],
    region: "美国",
    language: "英语",
    rating: 8.8,
    popularity: 933,
    duration: "每集 51 分钟",
    episodes: "已更新 4 季",
    director: "达菲兄弟",
    cast: ["米莉·博比·布朗", "芬恩·伍法德", "薇诺娜·瑞德"],
    synopsis:
      "小镇男孩的失踪揭开实验室的秘密，一群骑着自行车的孩子撞见了来自颠倒世界的怪物。八十年代怀旧风扑面而来。",
    tags: ["热播", "高分"],
    awards: ["6 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=retro%20eighties%20sci-fi%20horror%20poster%20art%20of%20a%20group%20of%20kids%20on%20bicycles%20before%20a%20glowing%20red%20rift%20in%20a%20dark%20forest%2C%20neon%20red%20and%20deep%20blue%2C%20moody%20atmosphere&width=480&height=640&seq=tv-04&orientation=portrait",
  },
  {
    id: "t-05",
    title: "王冠",
    originalTitle: "The Crown",
    type: "tv",
    year: 2016,
    endYear: 2023,
    genres: ["剧情", "历史", "传记"],
    region: "英国",
    language: "英语",
    rating: 9.3,
    popularity: 872,
    duration: "每集 58 分钟",
    episodes: "全 6 季 60 集",
    director: "彼得·摩根",
    cast: ["克莱尔·芙伊", "奥利维娅·科尔曼", "艾美达·斯丹顿"],
    synopsis:
      "从年轻的伊丽莎白二世登基讲起，王室在时代洪流中的抉择与隐忍被细腻铺陈。权杖之下，是责任与个人的漫长博弈。",
    tags: ["高分", "经典"],
    awards: ["多项艾美奖最佳剧集"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20royal%20period%20drama%20poster%20art%20of%20a%20regal%20woman%20in%20an%20ornate%20crown%20and%20jeweled%20gown%20in%20a%20grand%20palace%20hall%2C%20warm%20gold%20and%20deep%20blue%20tones%2C%20refined%20style&width=480&height=640&seq=tv-05&orientation=portrait",
  },
  {
    id: "t-06",
    title: "切尔诺贝利",
    originalTitle: "Chernobyl",
    type: "tv",
    year: 2019,
    genres: ["剧情", "历史", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 9.6,
    popularity: 896,
    duration: "每集 65 分钟",
    episodes: "全 1 季 5 集",
    director: "约翰·伦克",
    cast: ["杰瑞德·哈里斯", "斯特兰·斯卡斯加德", "艾米丽·沃森"],
    synopsis:
      "1986 年的核电站事故，以及为真相奔走的科学家们。一场人为灾难背后，是谎言与勇气之间的殊死较量。",
    tags: ["高分", "经典"],
    awards: ["10 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=bleak%20historical%20disaster%20poster%20art%20of%20a%20burning%20nuclear%20power%20plant%20silhouette%20at%20dusk%20with%20a%20glowing%20blue%20beam%20into%20the%20sky%2C%20smoke%20and%20grey%20clouds%2C%20somber%20tone&width=480&height=640&seq=tv-06&orientation=portrait",
  },
  {
    id: "t-07",
    title: "最后生还者",
    originalTitle: "The Last of Us",
    type: "tv",
    year: 2023,
    genres: ["剧情", "冒险", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 8.7,
    popularity: 908,
    duration: "每集 56 分钟",
    episodes: "已更新 1 季 9 集",
    director: "克雷格·麦辛",
    cast: ["佩德罗·帕斯卡", "贝拉·拉姆齐", "加布里埃尔·卢纳"],
    synopsis:
      "真菌病毒摧毁文明二十年后，走私者护送一名免疫少女穿越废墟之国。冰冷末世里，两个陌生人成为彼此唯一的依靠。",
    tags: ["热播", "新片"],
    awards: ["8 项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=post%20apocalyptic%20drama%20poster%20art%20of%20a%20rugged%20man%20and%20a%20young%20girl%20walking%20through%20overgrown%20abandoned%20city%20buildings%2C%20fog%20and%20moss%2C%20muted%20green%20and%20grey%20tones&width=480&height=640&seq=tv-07&orientation=portrait",
  },
  {
    id: "t-08",
    title: "神探夏洛克",
    originalTitle: "Sherlock",
    type: "tv",
    year: 2010,
    endYear: 2017,
    genres: ["悬疑", "犯罪", "剧情"],
    region: "英国",
    language: "英语",
    rating: 9.3,
    popularity: 869,
    duration: "每集 88 分钟",
    episodes: "全 4 季 13 集",
    director: "马克·加蒂斯",
    cast: ["本尼迪克特·康伯巴奇", "马丁·弗瑞曼", "鲁伯特·格雷夫斯"],
    synopsis:
      "把福尔摩斯搬到现代伦敦。高智商侦探与退役军医的搭档，用手机、短信与推理破解一桩桩离奇案件。",
    tags: ["经典", "高分"],
    awards: ["多项艾美奖与英国电视学院奖"],
    cover:
      "https://readdy.ai/api/search-image?query=modern%20detective%20poster%20art%20of%20a%20sharp%20dressed%20man%20in%20a%20long%20coat%20holding%20a%20magnifier%20on%20a%20foggy%20london%20street%20at%20night%2C%20warm%20streetlamp%20glow%2C%20smoky%20blue%20tones&width=480&height=640&seq=tv-08&orientation=portrait",
  },
  {
    id: "t-09",
    title: "黑镜",
    originalTitle: "Black Mirror",
    type: "tv",
    year: 2011,
    endYear: 2023,
    genres: ["科幻", "惊悚", "剧情"],
    region: "英国",
    language: "英语",
    rating: 9.0,
    popularity: 851,
    duration: "每集 60 分钟",
    episodes: "全 6 季",
    director: "查理·布鲁克",
    cast: ["众多独立单元主演", "布莱丝·达拉斯·霍华德", "乔恩·哈姆"],
    synopsis:
      "每一集都是一个关于科技与人性的独立寓言。当屏幕越来越亮，我们是否正在亲手打造自己的黑色镜子？",
    tags: ["高分", "经典"],
    awards: ["多项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=dystopian%20tech%20anthology%20poster%20art%20of%20a%20cracked%20glowing%20smartphone%20screen%20reflecting%20a%20distorted%20human%20face%2C%20dark%20background%2C%20cold%20blue%20glow%2C%20minimal%20high%20contrast&width=480&height=640&seq=tv-09&orientation=portrait",
  },
  {
    id: "t-10",
    title: "西部世界",
    originalTitle: "Westworld",
    type: "tv",
    year: 2016,
    endYear: 2022,
    genres: ["科幻", "西部", "悬疑"],
    region: "美国",
    language: "英语",
    rating: 8.7,
    popularity: 823,
    duration: "每集 62 分钟",
    episodes: "全 4 季 36 集",
    director: "乔纳森·诺兰",
    cast: ["埃文·蕾切尔·伍德", "坦迪·牛顿", "安东尼·霍普金斯"],
    synopsis:
      "在可以肆意妄为的主题公园里，接待员机器人逐渐觉醒。当造物开始追问自己是谁，乐园的规则便彻底崩坏。",
    tags: ["高分"],
    awards: ["多项艾美奖"],
    cover:
      "https://readdy.ai/api/search-image?query=western%20sci-fi%20poster%20art%20of%20a%20lone%20cowboy%20silhouette%20on%20a%20desert%20mesa%20at%20sunset%20with%20a%20subtle%20robotic%20hand%20reveal%2C%20warm%20amber%20dust%20and%20teal%20sky&width=480&height=640&seq=tv-10&orientation=portrait",
  },
  {
    id: "t-11",
    title: "纸牌屋",
    originalTitle: "House of Cards",
    type: "tv",
    year: 2013,
    endYear: 2018,
    genres: ["剧情", "惊悚", "政治"],
    region: "美国",
    language: "英语",
    rating: 8.9,
    popularity: 812,
    duration: "每集 51 分钟",
    episodes: "全 6 季 73 集",
    director: "鲍尔·威利蒙",
    cast: ["凯文·史派西", "罗宾·怀特", "迈克尔·凯利"],
    synopsis:
      "野心勃勃的国会议员与妻子联手，一步步攀向权力之巅。华盛顿的权力游戏里，微笑背后都是精心计算的刀刃。",
    tags: ["高分", "经典"],
    awards: ["多项艾美奖提名"],
    cover:
      "https://readdy.ai/api/search-image?query=dark%20political%20thriller%20poster%20art%20of%20a%20confident%20man%20in%20a%20dark%20suit%20standing%20before%20a%20washington%20monument%20fog%20at%20night%2C%20cold%20blue%20and%20black%20tones%2C%20sharp%20lighting&width=480&height=640&seq=tv-11&orientation=portrait",
  },
  {
    id: "t-12",
    title: "绝命律师",
    originalTitle: "Better Call Saul",
    type: "tv",
    year: 2015,
    endYear: 2022,
    genres: ["剧情", "犯罪"],
    region: "美国",
    language: "英语",
    rating: 9.2,
    popularity: 845,
    duration: "每集 47 分钟",
    episodes: "全 6 季 63 集",
    director: "文斯·吉利根",
    cast: ["鲍勃·奥登科克", "乔纳森·班克斯", "蕾亚·塞洪"],
    synopsis:
      "《绝命毒师》前传，讲述小律师吉米如何一步步变成游走在灰色地带的索尔·古德曼。小人物的挣扎格外动人。",
    tags: ["高分", "经典"],
    awards: ["多项艾美奖提名"],
    cover:
      "https://readdy.ai/api/search-image?query=retro%20legal%20drama%20poster%20art%20of%20a%20slick%20lawyer%20in%20a%20bright%20suit%20holding%20a%20briefcase%20in%20a%20neon%20lit%20desert%20parking%20lot%2C%20warm%20amber%20and%20deep%20blue%20night%20tones&width=480&height=640&seq=tv-12&orientation=portrait",
  },
  {
    id: "t-13",
    title: "浴血黑帮",
    originalTitle: "Peaky Blinders",
    type: "tv",
    year: 2013,
    endYear: 2022,
    genres: ["剧情", "犯罪", "历史"],
    region: "英国",
    language: "英语",
    rating: 8.9,
    popularity: 838,
    duration: "每集 58 分钟",
    episodes: "全 6 季 36 集",
    director: "史蒂文·奈特",
    cast: ["基里安·墨菲", "海伦·麦克洛瑞", "保罗·安德森"],
    synopsis:
      "一战后的伯明翰，谢尔比家族戴着缝着刀片的帽子，从地下赌场一路扩张成帝国。优雅与暴力并存的黑帮史诗。",
    tags: ["高分", "热播"],
    awards: ["英国电视学院奖最佳剧集"],
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20period%20gangster%20poster%20art%20of%20a%20sharp%20man%20in%20a%20flat%20cap%20and%20tweed%20coat%20smoking%20in%20a%20smoky%20industrial%20street%2C%20warm%20sepia%20and%20grey%20tones%2C%20gritty%20elegant&width=480&height=640&seq=tv-13&orientation=portrait",
  },
  {
    id: "t-14",
    title: "毒枭",
    originalTitle: "Narcos",
    type: "tv",
    year: 2015,
    endYear: 2017,
    genres: ["剧情", "犯罪", "传记"],
    region: "美国",
    language: "英语",
    rating: 9.0,
    popularity: 826,
    duration: "每集 49 分钟",
    episodes: "全 3 季 30 集",
    director: "何塞·帕迪利亚",
    cast: ["瓦格纳·马拉", "佩德罗·帕斯卡", "乔安娜·克里斯蒂"],
    synopsis:
      "哥伦比亚缉毒战争的纪实性剧集。从毒枭的崛起到追捕的刀光剑影，真实与戏剧在硝烟中交织。",
    tags: ["高分"],
    awards: ["多项艾美奖提名"],
    cover:
      "https://readdy.ai/api/search-image?query=tense%20crime%20drama%20poster%20art%20of%20a%20man%20in%20a%20colorful%20shirt%20standing%20in%20a%20humid%20latin%20american%20street%20with%20a%20helicopter%20above%2C%20green%20jungle%20and%20warm%20sunlight%2C%20documentary%20feel&width=480&height=640&seq=tv-14&orientation=portrait",
  },
  {
    id: "t-15",
    title: "唐顿庄园",
    originalTitle: "Downton Abbey",
    type: "tv",
    year: 2010,
    endYear: 2015,
    genres: ["剧情", "历史"],
    region: "英国",
    language: "英语",
    rating: 9.1,
    popularity: 794,
    duration: "每集 50 分钟",
    episodes: "全 6 季 52 集",
    director: "朱利安·费罗斯",
    cast: ["休·博内威利", "伊丽莎白·麦戈文", "玛吉·史密斯"],
    synopsis:
      "爱德华时代的贵族庄园，楼上楼下的世界同样精彩。家族兴衰与仆人命运交织，尽显英式古典的优雅与克制。",
    tags: ["经典", "高分"],
    awards: ["多项艾美奖与金球奖"],
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20british%20period%20drama%20poster%20art%20of%20a%20grand%20stone%20manor%20house%20surrounded%20by%20manicured%20gardens%20at%20golden%20hour%2C%20vintage%20car%20at%20entrance%2C%20warm%20green%20and%20amber%20tones&width=480&height=640&seq=tv-15&orientation=portrait",
  },
  {
    id: "t-16",
    title: "我们这一天",
    originalTitle: "This Is Us",
    type: "tv",
    year: 2016,
    endYear: 2022,
    genres: ["剧情", "家庭"],
    region: "美国",
    language: "英语",
    rating: 8.8,
    popularity: 781,
    duration: "每集 43 分钟",
    episodes: "全 6 季 106 集",
    director: "丹·福格尔曼",
    cast: ["米洛·文堤米利亚", "曼迪·摩尔", "斯特林·K·布朗"],
    synopsis:
      "同一个家庭三代人的时间线交错展开。平凡日子里的欢喜与遗憾，被温柔地串成一封写给生活的长信。",
    tags: ["高分", "经典"],
    awards: ["艾美奖最佳剧集提名"],
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20poster%20art%20of%20a%20happy%20family%20gathered%20in%20a%20sunlit%20living%20room%20celebrating%20a%20birthday%20with%20balloons%2C%20warm%20amber%20tones%2C%20tender%20mood&width=480&height=640&seq=tv-16&orientation=portrait",
  },
  {
    id: "t-17",
    title: "良医",
    originalTitle: "The Good Doctor",
    type: "tv",
    year: 2017,
    endYear: 2024,
    genres: ["剧情", "医疗"],
    region: "美国",
    language: "英语",
    rating: 8.4,
    popularity: 766,
    duration: "每集 43 分钟",
    episodes: "全 7 季 126 集",
    director: "大卫·肖",
    cast: ["弗莱迪·海默", "希尔·哈珀", "安东尼娅·托马斯"],
    synopsis:
      "患有自闭症的天才外科医生肖恩，用与众不同的方式理解世界、拯救病人。在质疑声中，他一次次证明自己的价值。",
    tags: ["热播"],
    awards: ["金球奖最佳男主角提名"],
    cover:
      "https://readdy.ai/api/search-image?query=clean%20medical%20drama%20poster%20art%20of%20a%20focused%20young%20doctor%20in%20a%20white%20coat%20holding%20a%20stethoscope%20in%20a%20bright%20hospital%20corridor%2C%20cool%20blue%20and%20white%20tones%2C%20calm%20clinical%20feel&width=480&height=640&seq=tv-17&orientation=portrait",
  },
  {
    id: "t-18",
    title: "亢奋",
    originalTitle: "Euphoria",
    type: "tv",
    year: 2019,
    endYear: 2024,
    genres: ["剧情", "青春"],
    region: "美国",
    language: "英语",
    rating: 8.2,
    popularity: 743,
    duration: "每集 55 分钟",
    episodes: "已更新 2 季 18 集",
    director: "萨姆·莱文森",
    cast: ["赞达亚", "亨特·莎弗", "雅各布·艾洛蒂"],
    synopsis:
      "一群高中生在成长、成瘾与身份认同之间跌跌撞撞。迷幻的影像语言下，是青春最锋利也最脆弱的剖面。",
    tags: ["热播"],
    awards: ["艾美奖最佳女主角"],
    cover:
      "https://readdy.ai/api/search-image?query=neon%20teen%20drama%20poster%20art%20of%20a%20young%20woman%20with%20glitter%20makeup%20under%20vivid%20magenta%20and%20blue%20nightclub%20lights%2C%20bokeh%20sparkle%2C%20dreamy%20cinematic%20mood&width=480&height=640&seq=tv-18&orientation=portrait",
  },
  {
    id: "t-19",
    title: "亿万",
    originalTitle: "Billions",
    type: "tv",
    year: 2016,
    endYear: 2023,
    genres: ["剧情", "金融"],
    region: "美国",
    language: "英语",
    rating: 8.4,
    popularity: 728,
    duration: "每集 55 分钟",
    episodes: "全 7 季 84 集",
    director: "布莱恩·科佩尔曼",
    cast: ["保罗·吉亚玛提", "戴米恩·路易斯", "玛姬·丝弗"],
    synopsis:
      "纽约检察官与华尔街对冲基金巨头之间的一场持久博弈。金钱、权力与智谋的较量，在玻璃幕墙间步步升级。",
    tags: ["高分"],
    awards: ["金球奖最佳男主角提名"],
    cover:
      "https://readdy.ai/api/search-image?query=sharp%20financial%20drama%20poster%20art%20of%20two%20rival%20businessmen%20in%20suits%20facing%20each%20other%20across%20a%20glass%20office%20overlooking%20manhattan%20skyline%2C%20cool%20blue%20and%20grey%20tones&width=480&height=640&seq=tv-19&orientation=portrait",
  },
  {
    id: "t-20",
    title: "犯罪心理",
    originalTitle: "Criminal Minds",
    type: "tv",
    year: 2005,
    endYear: 2020,
    genres: ["悬疑", "犯罪", "惊悚"],
    region: "美国",
    language: "英语",
    rating: 8.9,
    popularity: 755,
    duration: "每集 42 分钟",
    episodes: "全 15 季 324 集",
    director: "杰夫·戴维斯",
    cast: ["托马斯·吉布森", "谢玛·摩尔", "马修·格雷·古柏勒"],
    synopsis:
      "FBI 行为分析小组通过犯罪心理侧写追捕连环案犯。在人性最幽暗的角落里，他们寻找破案的唯一线索。",
    tags: ["经典", "高分"],
    awards: ["多项人民选择奖"],
    cover:
      "https://readdy.ai/api/search-image?query=tense%20procedural%20crime%20poster%20art%20of%20an%20fbi%20team%20walking%20toward%20a%20dim%20crime%20scene%20lit%20by%20blue%20flashing%20lights%2C%20rainy%20street%2C%20cold%20noir%20tones&width=480&height=640&seq=tv-20&orientation=portrait",
  },
];